import * as React from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useSubjects } from './hooks'

export function StandardSubjectSelect({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  const { subjects, loadingSubjects, fetchSubjects } = useSubjects()

  // Fetch subjects on mount
  React.useEffect(() => {
    if (!subjects && !loadingSubjects) {
      fetchSubjects()
    }
  }, [subjects, loadingSubjects, fetchSubjects])

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="subject-select-label">Subject</InputLabel>
      <Select
        labelId="subject-select-label"
        id="subject-select"
        value={value}
        label="Subject"
        onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
      >
        {!subjects ? (
          <MenuItem disabled>Loading subjects...</MenuItem>
        ) : (
          subjects.map((subject) => (
            <MenuItem
              dense
              key={subject.subject_name}
              value={subject.subject_name}
            >
              {subject.subject_name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  )
}
